import { render, staticRenderFns } from "./enlazar.vue?vue&type=template&id=0f6c4740"
import script from "./enlazar.vue?vue&type=script&lang=js"
export * from "./enlazar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports